"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SurveyQuestionTypeEnum;
(function (SurveyQuestionTypeEnum) {
    SurveyQuestionTypeEnum[SurveyQuestionTypeEnum["Text"] = 'text'] = "Text";
    SurveyQuestionTypeEnum[SurveyQuestionTypeEnum["Checkbox"] = 'checkbox'] = "Checkbox";
    SurveyQuestionTypeEnum[SurveyQuestionTypeEnum["Button"] = 'button'] = "Button";
    SurveyQuestionTypeEnum[SurveyQuestionTypeEnum["DropDown"] = 'drop-down-list'] = "DropDown";
    SurveyQuestionTypeEnum[SurveyQuestionTypeEnum["Option"] = 'option-box'] = "Option";
    SurveyQuestionTypeEnum[SurveyQuestionTypeEnum["TrueOrFalse"] = 'true-or-false'] = "TrueOrFalse";
    SurveyQuestionTypeEnum[SurveyQuestionTypeEnum["ScaleOf5"] = 'scale-of-5'] = "ScaleOf5";
    SurveyQuestionTypeEnum[SurveyQuestionTypeEnum["ScaleOf10"] = 'scale-of-10'] = "ScaleOf10";
})(SurveyQuestionTypeEnum = exports.SurveyQuestionTypeEnum || (exports.SurveyQuestionTypeEnum = {}));
exports.SurveyQuestionTypesWithMeasures = [SurveyQuestionTypeEnum.ScaleOf10, SurveyQuestionTypeEnum.ScaleOf5];
exports.SurveyQuestionMeasureOptionsPlaceholder = ['Lowest', 'Medium', 'Highest'];
exports.SurveyQuestionTypesWithRegularOptions = [SurveyQuestionTypeEnum.Button, SurveyQuestionTypeEnum.Checkbox, SurveyQuestionTypeEnum.Option, SurveyQuestionTypeEnum.DropDown];
exports.SurveyQuestionTypesWithOptions = [...exports.SurveyQuestionTypesWithRegularOptions, ...exports.SurveyQuestionTypesWithMeasures];
class Survey {
    static create(data) {
        return Object.assign(new Survey(), data);
    }
}
exports.default = Survey;


//////////////////
// WEBPACK FOOTER
// ./client/src/models/Survey.ts
// module id = 479
// module chunks = 0 1 2